import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { UniversityResult } from '../models/university-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the University Finder. Calls the AirportsAPI `~/universities` endpoint. Category facet
 * filtering (Degrees / Majors / Accreditation / ...) is applied client-side in {@link SearchPageComponent};
 * this service performs only the location/state/keyword query.
 */
var UniversitiesService = /** @class */ (function (_super) {
    tslib_1.__extends(UniversitiesService, _super);
    function UniversitiesService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'universities';
        return _this;
    }
    UniversitiesService.prototype.parse = function (data) {
        return UniversityResult.parse(data);
    };
    UniversitiesService.prototype.getUniversitiesByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    UniversitiesService.prototype.getUniversitiesByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    UniversitiesService.prototype.getUniversitiesByState = function (state) {
        return this.getByState(state);
    };
    UniversitiesService.prototype.getUniversitiesBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    /**
     * Returns every university nationwide. Used when no location/keyword was entered — unlike the other
     * finders, there are few enough universities (~300) that an unscoped search returns the whole dataset
     * instead of requiring a location.
     */
    UniversitiesService.prototype.getAllUniversities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._http.post(this.url, {}).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.map(function (d) { return _this.parse(d); })];
                    case 2:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UniversitiesService.ngInjectableDef = i0.defineInjectable({ factory: function UniversitiesService_Factory() { return new UniversitiesService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: UniversitiesService, providedIn: "root" });
    return UniversitiesService;
}(BusinessFinderService));
export { UniversitiesService };
